var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 4.8125L5.67188 18.5625C5.7127 19.357 6.29062 19.9375 7.04688 19.9375H14.9531C15.7124 19.9375 16.2796 19.357 16.3281 18.5625L17.1875 4.8125",
    fill: "none",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 4.8125H18.5625Z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 4.8125H18.5625",
    fill: "none",
    strokeWidth: 1.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 7.56251L13.75 17.1875M8.25 4.8125V3.09375C8.2496 2.95822 8.27601 2.82394 8.32769 2.69864C8.37938 2.57335 8.45532 2.4595 8.55116 2.36367C8.647 2.26783 8.76084 2.19188 8.88614 2.14019C9.01143 2.08851 9.14571 2.06211 9.28125 2.0625H12.7188C12.8543 2.06211 12.9886 2.08851 13.1139 2.14019C13.2392 2.19188 13.353 2.26783 13.4488 2.36367C13.5447 2.4595 13.6206 2.57335 13.6723 2.69864C13.724 2.82394 13.7504 2.95822 13.75 3.09375V4.8125H8.25ZM11 7.56251V17.1875V7.56251ZM7.90625 7.56251L8.25 17.1875L7.90625 7.56251Z",
    fill: "none",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2046162a293b564920ba4fcc269f4ada.svg";
export { ForwardRef as ReactComponent };